export enum CardStyle {
  default = 'default',
  profile = 'profile',
}
